import { EventEmitter } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { ModalHelper } from '../../components/modal/modal.helper';
import { UtilsService } from '../../services/utils.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var PauseComponent = (function () {
    function PauseComponent(_data, _blogic, _utils, _modal) {
        this._data = _data;
        this._blogic = _blogic;
        this._utils = _utils;
        this._modal = _modal;
        this.listChanged = new EventEmitter();
        this.pausedList = [];
        this.destroy$ = new Subject();
        this.autoSupervisorInterval = null;
    }
    PauseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._updateTurn(this._data.turn);
        this._data.turnUpdate
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._updateTurn(response);
        });
        this._getPausedList();
    };
    PauseComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    /* When the turn information change */
    PauseComponent.prototype._updateTurn = function (turn) {
        if (!this._data.turnIsActive()) {
            this.turn = null;
        }
        else {
            this.turn = turn;
        }
    };
    /* Pause the actual turn */
    PauseComponent.prototype.pause = function () {
        var _this = this;
        var params = {
            desk_id: this._data.session["desk"],
            turn_id: this._data.turn["id"],
            pause: true,
            deskuser: this._data.session["username"]
        };
        this._blogic.setPausedTicket(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.actionContainer = 0;
            _this._data.closeTurn();
            _this._getPausedList();
        });
    };
    /* Recovery paused turn */
    PauseComponent.prototype.recovery = function (id) {
        var _this = this;
        var params = {
            desk_id: this._data.session["desk"],
            turn_id: id,
            pause: false,
            deskuser: this._data.session["username"]
        };
        this._data.pauseModalTurn = true;
        this._blogic.setPausedTicket(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.actionContainer = 0;
            _this.getTurn();
            _this._getPausedList();
            _this._modal.hide("pausedModal");
        });
    };
    /* Get the paused turn list */
    PauseComponent.prototype._getPausedList = function () {
        var _this = this;
        var params = {
            desk_id: this._data.session["desk"]
        };
        this._blogic.getDeskPaused(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.pausedList = response;
        });
    };
    /* Get a turn */
    PauseComponent.prototype.getTurn = function () {
        var _this = this;
        var params = {
            desk_id: this._data.session["desk"],
            status: "query"
        };
        this._blogic.deskNotify(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.turn = response;
        });
    };
    PauseComponent.prototype.getTurnNoPause = function () {
        var _this = this;
        var params = {
            desk_id: this._data.session["desk"],
            status: "A",
            deskuser: this._data.session["username"],
            deskoperator: this._data.session["operator"],
        };
        this._blogic.deskNotify(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.listChanged.emit(true);
            if (response == null) {
                _this._data.closeTurn();
            }
            else {
                _this._data.turn = response;
            }
        });
    };
    /* Open paused modal */
    PauseComponent.prototype.openPausedModal = function () {
        this._data.pauseModalTurn = true;
        this._modal.show("pausedModal");
        var self = this;
        $('#pausedModal').on('hidden.bs.modal', function (e) {
            self._data.pauseModalTurn = false;
            if (self._data.session['autosupervisor']) {
                self.autoSupervisorInterval = setTimeout(function () {
                    self.getTurnNoPause();
                }, parseInt((self._data.session['autosupervisor_delaytime'])) * 1000);
            }
        });
    };
    return PauseComponent;
}());
export { PauseComponent };
